import Vue from "vue";

export default {
  setUserGeoIP(state, userGeoIP) {
    Vue.set(state, "userGeoIP", userGeoIP);
  },
};
